export default "__VITE_ASSET__cdef7adf__"